import { Injectable } from '@angular/core';
import { scanImageData } from 'zbar.wasm';

@Injectable({
  providedIn: 'root'
})
export class ZBarService {

  constructor() { }
}
